
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { KioskFormPasswordField } from './KioskFormPasswordField/KioskFormPasswordField';
import { FormPasswordFieldProps } from './FormPasswordField.types';
import { WebFormPasswordField } from './WebFormPasswordField/WebFormPasswordField';

const FormPasswordField = ({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.NumberPad,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
}: FormPasswordFieldProps) => {
    return isElectron() ? (
        <KioskFormPasswordField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            onChangeCallback={onChangeCallback}
        />
    ) : (
        <WebFormPasswordField
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            onChangeCallback={onChangeCallback}
        />
    );
};

export default FormPasswordField;
